/** Color theme ids that enable Tailwind `dark` on `<html>`. Keep in sync with ThemeContext dark themes. */
export const DARK_COLOR_THEME_KEYS = new Set(['qms_dark', 'midnight_blue']);

export function isDarkColorThemeKey(themeKey) {
  return DARK_COLOR_THEME_KEYS.has(themeKey);
}
